<template>
  <el-dialog :title="title" :visible.sync="dialogFormVisible" custom-class="medium-dialog" center
             :close-on-click-modal="false" :append-to-body="true">
    <el-form :model="form" ref="form1" :rules="rules">
      <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="医院名称" :label-width="formLabelWidth" prop="deptname">
                  <el-input v-model="form.deptname" auto-complete="off" :required="true" :readonly="form.casestatus>=9"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20" v-if="form.casestatus<9">
            <el-col :span="24">
              <el-form-item label="所属区域" :label-width="formLabelWidth" prop="county">
                <v-distpicker :province="form.province" @province="onChangeProvince" :city="form.city"
                              @city="onChangeCity" :area="form.county" @area="onChangeArea"></v-distpicker>
              </el-form-item>
            </el-col>
     </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="地址" :label-width="formLabelWidth" prop="deliveryaddress">
            {{form.province}}{{form.city}}{{form.county}}<el-input v-model="form.deliveryaddress" auto-complete="off"  :required="true" style="width: 50%" :readonly="form.casestatus>=9"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="hospitaldata.length>0">
        <el-col :span="24">
          <el-table :data="hospitaldata" size="mini" stripe border style="width: 100%;margin-bottom: 30px">
            <el-table-column prop="deptname"  label="名称" align="left" header-align="center" :show-overflow-tooltip="true" width="260"></el-table-column>
            <el-table-column prop="tenantname" label="服务商" align="left" header-align="center" :show-overflow-tooltip="true" width="160"></el-table-column>
            <el-table-column prop="deliveryaddress" label="地址" align="left" header-align="center" :show-overflow-tooltip="true" width="330"></el-table-column>
            <el-table-column prop="validitydate" label="有效期" header-align="center" align="left" width="90">
              <template slot-scope="scope">
                <span v-if="scope.row.casestatus<9">{{scope.row.validitydate?scope.row.validitydate.replace("00:00:00",""):""}}</span>
              </template>
            </el-table-column>
            <el-table-column width="100" label="状态" align="center">
              <template slot-scope="scope">
                <el-tag :type="'danger'" v-if="scope.row.casestatus==0">待授权</el-tag>
                <el-tag :type="'success'" v-if="scope.row.casestatus==1">洽谈中</el-tag>
                <el-tag :type="'primary'" v-if="scope.row.casestatus==9">已签约</el-tag>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <el-row :gutter="20" v-if="isEditPage">
        <el-col :span="12" v-if="form.casestatus<9">
          <el-form-item label="有效期" :label-width="formLabelWidth" prop="validitydate">
            <el-date-picker  v-model="form.validitydate" type="date" :required="true" :picker-options="pickerOptions" style="width: 150px"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="保证金" :label-width="formLabelWidth" prop="bond">
            <el-input v-model="form.bond" auto-complete="off" style="width: 150px"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="备注" :label-width="formLabelWidth" prop="descri">
           <el-input v-model="form.descri" auto-complete="off" type="textarea"  :rows="2"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!--<el-row :gutter="20">-->
        <!--<el-col :span="24">-->
          <!--<el-form-item label="联系人" :label-width="formLabelWidth" prop="linkman">-->
            <!--<el-input v-model="form.linkman" auto-complete="off"  :required="true"></el-input>-->
          <!--</el-form-item>-->
        <!--</el-col>-->
      <!--</el-row>-->
      <!--<el-row :gutter="20">-->
        <!--<el-col :span="24">-->
          <!--<el-form-item label="手机号" :label-width="formLabelWidth" prop="linkmantel">-->
            <!--<el-input v-model="form.linkmantel" auto-complete="off"  :required="true"></el-input>-->
          <!--</el-form-item>-->
        <!--</el-col>-->
      <!--</el-row>-->
          <el-row :gutter="25">
            <el-col :span="12">
              <el-form-item label="附件" :label-width="formLabelWidth" prop="attguid">
                <CommonUpload ref="refattguid" :multiple="true" :groupGuid="form.attguid" :disabled="form.casestatus>=9"
                              groupType="fixtenanthospitail" :limit="10"></CommonUpload>
              </el-form-item>
            </el-col>
          </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">关 闭</el-button>
      <el-button type="primary" @click="saveData" v-if="canEdit&&!isEditPage">提 交</el-button>
      <el-button type="primary" @click="auditData(null)" v-if="canEdit&&isEditPage">暂 存</el-button>
      <el-button type="success" @click="auditData(1)" v-if="canEdit&&isEditPage&&form.casestatus==0">授 权</el-button>
      <el-button type="success" @click="auditData(9)" v-if="canEdit&&isEditPage&&form.casestatus==1">签 约</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import {savehospital,listdeptpre,listhospital,removehospital,updatehospital,detailhospital} from '@/api/set/externaldept';
  import {attUUID} from '@/api/attachment';
  import {getParameterDetail} from '@/api/set/parameter';

  export default {
    name: "hospitalAdd",
    data() {
      return {
        canEdit:false,
        title:"增加医院",
        dialogFormVisible: false,
        isEditPage:false,
        settingmenthod:[],
        storecontent:{},
        hospitaldata:[],
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() > new Date(Date.now() + 90 * 24 * 60 * 60 * 1000);
          },
        },
        form: {  //表单数据
          unitguid:'',
          tenantid: '',
          deptname: '',
          province: '',
          city: '',
          county: '',
          deliveryaddress: '',
          casestatus:'0',
          descri: '',
          bond: '',
          validitydate: '',
          attguid: '',
          audittenantid:''
        },
        formLabelWidth: '120px',
        formLabelWidth2: '70px',
        rules: {////////定义正则验证字段。
          deptname: [
            {required: true, message: '请输入门店名称', trigger: 'blur'},
          ],
          deliveryaddress: [
            {required: true, message: '请输入门店地址', trigger: 'blur'},
          ],
          county: [
            {required: true, message: '请选择所属区域', trigger: 'blur'},
          ],
          validitydate: [
            {required: true, message: '请输入有效期', trigger: 'blur'},
          ],
          linkmantel: [
            {required: true, message: '请输入手机号', trigger: 'blur'},
          ]
        },
      }
    },
    props: {
      managetenantid: {
        default: ""
      },
      ismanage:{
        default:false,
      }
    },
    methods: {
      onChangeProvince(data) {
        if (data.value == '省') data.value = '';
        this.form.province = data.value;
        this.form.city = ''
        this.form.county = ''
        this.hospitaldata = [];
      }, onChangeCity(data) {
        if (data.value == '市') data.value = '';
        this.form.city = data.value;
        this.form.county = ''
        this.hospitaldata = [];
      }, onChangeArea(data) {
        if (data.value == '区' || data.value == '县') data.value = '';
        this.form.county = data.value;
        this.listArea();
      },
      show() {
        this.title = "增加医院";
        this.isEditPage = false;
        this.form.unitguid='';
        this.form.casestatus = '0'
        this.form.audittenantid = this.managetenantid;
        this.form.deptname = ''
        this.form.province = ''
        this.form.city = ''
        this.form.county = ''
        this.form.bond = ''
        this.form.validitydate = null
        this.form.deliveryaddress = ''
        this.form.descri = ''
        this.form.attguid = attUUID();
        this.canEdit = true;
        if (this.$refs.refattguid) {
          this.$refs.refattguid.reset();
        }
        this.dialogFormVisible = true
      },
      showEdit(row) {
        this.title = row.tenantname;
        this.isEditPage = true;
        for (let key in this.form) {
          this.form[key] = row[key];
        }
        this.form.attguid=row.attguid;
        if (!this.form.validitydate) {
          var nowD = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000);
          this.form.validitydate = nowD.getFullYear() + "-" + (nowD.getMonth() + 1) + "-" + nowD.getDate();
        }
        this.form.audittenantid = this.managetenantid;
        this.canEdit = this.ismanage;
        this.listArea();
        this.dialogFormVisible = true;
      },
      saveData() {//录入医院

        if (this.$refs.refattguid) {
          var attFile=this.$refs.refattguid.getFiles();
          if(!attFile||attFile.length==0){
            this.$message({
              message: '附件必须上传！',
              type: 'error'
            })
            return;
          }
        }

        this.$refs.form1.validate((valid) => {
          if (valid) {
            savehospital(this.form).then(response => {
              if (response.data.code == 0) {
                this.$message({
                  message: '录入成功，等待审核！',
                  type: 'success'
                })
                this.dialogFormVisible = false;
                this.$emit('bindGrid');
              } else {
                this.$message({
                  message: response.data.msg,
                  type: 'error'
                })
              }
            });
          }
        })
      },
      getTenantName(rows){
        switch (rows.tenantid){
          case 'e5682784-dbb7-4eba-939f-4c265092db1d':
            return '南京起舵（广州分公司）';
            break;
          case 'd6d0f500-6c34-45e6-b206-b87c368e4469':
            return '南京起舵电子商务有限公司';
            break;
          case '79b768f5-f02b-4eb4-a5a3-330cbf41f377':
            return '南京起舵（东北分公司）';
            break;
          default:
            return rows.tenantname;
        }
      },
      padZERO(num){
        return num<10?('0'+num):num;
      },
      auditData(casestatus) {//授权医院
        this.$refs.form1.validate((valid) => {
          if (valid) {
            var saveData = {};
            for (let key in this.form) {
              saveData[key] = this.form[key];
            }
            if (casestatus)
              saveData.casestatus = casestatus;//转为洽谈中的状态
            if (saveData.validitydate) {
              var nowD = new Date(saveData.validitydate);
              saveData.validitydate = nowD.getFullYear() + "-" + this.padZERO(nowD.getMonth() + 1) + "-" + this.padZERO(nowD.getDate()) + " 0:00:00"
            }
            updatehospital(saveData).then(response => {
              if (response.data.code == 0) {
                this.$message({
                  message: '操作成功！',
                  type: 'success'
                })
                this.dialogFormVisible = false;
                this.$emit('bindGrid');
              } else {
                this.$message({
                  message: response.data.msg,
                  type: 'error'
                })
              }
            });
          }
        });
      },
      listArea() {
        this.hospitaldata = []
        if (this.isEditPage && this.canEdit && this.form.casestatus == 0) {
          listdeptpre({
            managetenantid: this.managetenantid,
            province: this.form.province,
            city: this.form.city,
            county: this.form.county
          }).then(resHospital => {
            var table = resHospital.data.obj.rows;
            for (let i in table) {
              if (table[i].unitguid != this.form.unitguid) {
                table[i].tenantname=this.getTenantName(table[i]);
                this.hospitaldata.push(table[i]);
              }
            }
          });
        }
      }
    },
    mounted() {

    },
    components: {}
  }
</script>


<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/workflow/hospital/hospitalAdd.vue